import { useEffect, useState } from "react";
import AddEvent from "./AddEvent";
import Event_calander from "./Event_calander";
import { useNavigate } from "react-router-dom";

function EventPage({ eventDetails }) {
  const navigate = useNavigate();

  const [events, setEvents] = useState([]);
  const [submitted, setSubmitted] = useState(false);

  function onAddEvent(event) {
    setEvents(prev => [...prev, event]);
    setSubmitted(true);
  }

  // ✅ Hooks ALWAYS first
  useEffect(() => {
    console.log("Event details received:", eventDetails);

    if (eventDetails && eventDetails.length > 0) {
      navigate("/eventCard", { state: eventDetails });
    }
  }, [eventDetails, navigate]);

  // ✅ Conditional UI AFTER hooks
  if (!eventDetails || eventDetails.length === 0) {
    return <p>No events available</p>;
  }

  return (
    <>
      {!submitted && (
        <>
          <AddEvent onAddEvent={onAddEvent} />
          <Event_calander events={events} />
        </>
      )}

      {submitted && (
        <h2 style={{ textAlign: "center", color: "green" }}>
          Event submitted successfully ✅
        </h2>
      )}
    </>
  );
}

export default EventPage;
